<template>

    <div class="hz-form-item" :class="isCustom?'hz-custorm-form':''">
        <div class="form-item" v-if="!(item.type=='custom')">
            <span v-show="item.required==1" class="is_required">*</span>
            <template v-if="item.type=='text'">
                <el-input @change="bindValue" @focus="onblur" v-model="currentValue"
                          :placeholder="item.placeholder&&multyLang[item.placeholder]?multyLang[item.placeholder][currentTranslateCode]:item.placeholder"></el-input>
            </template>

            <template v-if="item.type=='textarea'">
                <el-input type="textarea" @change="bindValue" @focus="onblur" v-model="currentValue"
                          :placeholder="item.placeholder&&multyLang[item.placeholder]?multyLang[item.placeholder][currentTranslateCode]:item.placeholder"></el-input>
            </template>

            <template v-if="item.type=='select'||item.type=='radio'">
                <!--<el-select v-model="value" placeholder="请选择">-->
                    <!--<el-option-->
                        <!--v-for="item in options"-->
                        <!--:key="item.value"-->
                        <!--:label="item.label"-->
                        <!--:value="item.value">-->
                    <!--</el-option>-->
                <!--</el-select>-->
                <el-select @focus="onblur" @change="bindValue" v-model="currentValue" :placeholder="multyLang[item.placeholder][currentTranslateCode]">
                    <el-option v-for="(i,j) in item.options"
                               :value="i.key" :label="multyLang.hasOwnProperty([i.value])?multyLang[i.value][currentTranslateCode]:i.value">{{multyLang.hasOwnProperty([i.value])?multyLang[i.value][currentTranslateCode]:i.value}}
                    </el-option>
                </el-select>
            </template>


            <template v-if="item.type=='checkbox'">
<!--                <el-checkbox-group   @change="bindCheckValue" v-model="checkList">-->
<!--                    <el-checkbox  v-for="(item,index) in item.options" :label="item.key"-->
<!--                                 :key="index">{{multyLang[item.value][currentTranslateCode]}}</el-checkbox>-->
<!--                </el-checkbox-group>-->
                <el-select multiple @focus="onblur" @change="bindCheckValue" v-model="checkList" :placeholder="multyLang[item.placeholder][currentTranslateCode]">
                    <el-option v-for="(i,j) in item.options"
                               :value="i.key" :label="multyLang.hasOwnProperty([i.value])?multyLang[i.value][currentTranslateCode]:i.value">{{multyLang.hasOwnProperty([i.value])?multyLang[i.value][currentTranslateCode]:i.value}}
                    </el-option>
                </el-select>

            </template>

            <!--校验多重数组-->
            <template v-if="item.type=='date'">
                <el-date-picker
                    @change="bindDateValue"
                    v-model="currentValue"
                    :placeholder="multyLang.hasOwnProperty([item.placeholder])? multyLang[item.placeholder][currentTranslateCode]:item.placeholder"
                    type="date">
                </el-date-picker>
            </template>
            <template v-if="item.type=='time'">
                <el-time-select
                    @change="bindValue"
                    v-model="currentValue"
                    :placeholder="multyLang.hasOwnProperty([item.placeholder])? multyLang[item.placeholder][currentTranslateCode]:item.placeholder">
                </el-time-select>
            </template>
            <template v-if="item.type=='datetime'">
                <el-date-picker
                    @change="bindDateValue"
                    v-model="currentValue"
                    :placeholder="multyLang.hasOwnProperty([item.placeholder])? multyLang[item.placeholder][currentTranslateCode]:item.placeholder"
                    type="datetime">
                </el-date-picker>
            </template>
            <template v-if="item.type=='multipleText'">
                <!--<div class="multy-item">-->
                <template v-for="(i,j) in currentForms[item.key]">
                    <div  class="el-form-item" v-if="item.type=='multipleText'"
                          :prop="`${item.key}[${j}]`">
                        <span v-show="item.required==1" class="is_required">*</span>
                        <el-input @focus="onblur" @change="bindValue"
                                  v-model="currentValue[j]"  :placeholder="item.placeholder&&multyLang[item.placeholder][currentTranslateCode]"></el-input>
                        <!--<i class="el-icon-circle-plus" v-show="j==0" @click="addOptions(item.key,'text')"></i>-->
                        <!--<i class="el-icon-remove" v-show="j>0" @click="removeOptions(item.key,j)"></i>-->
                    </div>
                </template>
                <!--</div>-->
            </template>
            <template v-if="item.type=='multipleSelect'">
                <!--<div class="multy-item">-->
                <template v-for="(i,j) in currentForms[item.key]">
                    <div  class="el-form-item" style="margin-bottom: 5px">
                        <span v-show="item.required==1" class="is_required">*</span>
                        <el-input @focus="onblur" @change="bindValue" style="width: 100%;margin-right: 8px"
                                  :placeholder="item.placeholder&&multyLang[item.placeholder][currentTranslateCode]" v-model="currentValue[j].value"
                                  class="input-with-select">
                            <el-select v-model="currentValue[j].key" style="width: 100px" slot="prepend"
                                       :placeholder="item.placeholder&&multyLang[item.placeholder][currentTranslateCode]">
                                <el-option v-for="(item,index) in item.options" :placeholder="multyLang[item.value][currentTranslateCode]"
                                           :value="item.key"></el-option>
                            </el-select>
                        </el-input>
                        <!--<i class="el-icon-circle-plus" v-show="j==0" @click="addOptions(item.key,'select')"></i>-->
                        <!--<i class="el-icon-remove" v-show="j>0" @click="removeOptions(item.key,j)"></i>-->
                    </div>
                </template>
                <!--</div>-->
            </template>

        </div>

    </div>
</template>


<script>
    import {baseChatUrl, baseUrl_1, baseUrl_8} from "../config/env";
    import {store,mutations} from "../store/index";

    export default {
        name: "createForm",
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
            currentform: {
                type: Object,
                default() {
                    return {}
                }
            },
            isCustom: {
                type: Boolean,
                default: false
            },
            value: ''
        },

        computed:{
            multyLang(){
                return store.multyLang
            },
            currentTranslateCode(){
                return store.currentTranslateCode
            }
        },

        watch:{
            multyLang(){
            },
            currentTranslateCode(){
            }
        },

        data() {
            return {
                currentForms: {},
                currentValue: '',
                checkList: [],
                options: [],
            }
        },
        created() {
            this.currentForms = Object.assign({}, this.currentform);
            this.currentValue = this.value;
            if (this.item.source == 1 && this.item.hasOwnProperty('dicClassId')) {
                this.getOptions();
            }
            if(this.item.type=='multipleText'){
                console.info(this.item);
            }
        },

        methods: {
            bindValue() {
                let _this = this;
                this.$emit('input', _this.currentValue);
                this.$emit('change', _this.currentValue);

            },

            bindCheckValue(){
                let _this = this;
                this.$emit('input', _this.checkList.join(','));
                this.$emit('change', _this.checkList.join(','));
            },

            bindDateValue(val){
                // this.currentValue = val;
                this.$emit('input', new Date(val).getTime()+'');
                this.$emit('change', new Date(val).getTime()+'');
            },
            onblur() {
                let _this = this;
                if (this.isCustom) {
                    this.$emit("changRadio", _this.item.key)
                }
            },
            getOptions() {
                let _this = this;
                let params = {
                    companyId: _this.item.companyId,
                    key: _this.item.key
                }
                $.get(baseUrl_1 + '/dic/getDicByKeyAndCompanyId', params).then((res) => {
                    if (res.code == this.$successCode) {
                        _this.item.options = [];
                        if (res.data && res.data.length > 0) {
                            res.data.forEach((item, index) => {
                                _this.item.options.push({
                                    key: item.dicId,
                                    value: item.dicValue
                                })
                            })
                        }
                    }
                })

            },

            computedRules(item) {
                let arr = [];
                if (item.required == 1 || item.required) {
                    if (item.type == 'text') {
                        let requireObj = {required: true, message: '请输入' + item.label, trigger: 'blur'};
                        arr.push(requireObj);
                    } else {
                        let requireObj = {required: true, message: '请输入' + item.label, trigger: 'change'};
                        arr.push(requireObj);
                    }
                }
                if (item.hasOwnProperty('validate') && item.validate && item.validate.rule.length > 0) {
                    arr.concat(item.validate.rule)
                }
                if (!this.rules[item.key]) {
                    this.rules[item.key] = arr;
                }
                return arr
            },
            addOptions(key, flag) {
                if (flag == 'select') {
                    this.currentValue.push({
                        key: '',
                        value: ''
                    })
                } else {
                    this.currentValue.push('')
                }

            },
            removeOptions(key, index) {
                this.currentValue.splice(index, 1);
            },

        },
    }
</script>

<style lang="scss">
    #hz_chat_app{
        .choose-input{
            .hz-form-item{
                .form-item{
                    width: 220px;
                }
            }

        }
       /*.multy-item{*/
           /*.el-form-item{*/
               /*position: relative;*/
           /*}*/
       /*}*/
        .hz-form-item {
            margin-bottom: 10px;
            position: relative;
            .form-item {
                margin: 0 auto;
                border-radius: 4px;
                width: 268px;
                .el-checkbox{
                    display: block;
                }

            }
            /*.multy-item {*/
                /*width: 100%;*/
                /*!*padding: 4px 16px 4px;*!*/
                /*!*background: rgba(216, 216, 216, 0.5);*!*/
            /*}*/
            .el-select {
                width: 100%;
            }
            .el-input__inner {
                width: 100% !important;
            }
            .el-input .el-input__inner {
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
            }
            .el-date-editor {
                width: 100%;
                /*box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.1);*/
            }

            textarea{
                padding: 8px 15px;
            }

            &.hz-custorm-form .el-input .el-input__inner {
                border: none;
            }
            .form-item .el-radio {
                margin-bottom: 5px;
                margin-top: 5px;
            }
            .el-checkbox-group {
                padding: 10px 0;
            }

            .is_required {
                color: #FF4D4F;
                position: absolute;
                font-size: 22px;
                right: 4px;
                top: 12px;
                display: block;
                height: 15px;

            }
           /* .multy-item .is_required {
                color: #FF4D4F;
                position: absolute;
                font-size: 22px;
                left: -13px;
                top: 5px;
                display: inline-block;
            }*/
            &.hz-custorm-form {
                display: inline-block;

                margin-bottom: 0px;
            }


            /*&.hz-custorm-form .multy-item {*/
                /*width: 220px;*/
                /*padding: 0;*/
                /*background: none;*/
            /*}*/
        }
        .el-icon-circle-plus {
            color: #428BCA;
            font-size: 16px;
            position: absolute;
            top:13px;
            right: -15px;
        }

        .el-icon-remove {
            color: #67788F;
            font-size: 16px;
            position: absolute;
            top:13px;
            right:-15px;
        }
        .choose-input{
            .el-icon-circle-plus {
                color: #428BCA;
                font-size: 16px;
                position: absolute;
                top:13px;
                right: -7px;
            }

            .el-icon-remove {
                color: #67788F;
                font-size: 16px;
                position: absolute;
                top:13px;
                right:-7px;
            }
        }
    }
</style>
